import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getGuestSearch = get('components.guestSearch');

export const getSearchBy = createSelector(getGuestSearch, get('searchBy'));
export const getBarcodeInput = createSelector(
  getGuestSearch,
  get('barcodeInput')
);
export const getColumnsInput = createSelector(
  getGuestSearch,
  get('columnsInput')
);
